<template>
  <a
    :href=link
    target="_blank"
    class="btn btnBStyle btnBFont"
    :style="{ backgroundColor: color, color: textColor, maxWidth: btnWidth }"
    v-bind:class="{ outlined: mode === 'outline' }"
  >
    <slot></slot>
    <i v-if="loading" class="fa fa-spin fa-spinner" style="color: white"></i>
  </a>
</template>

<script>
export default {
  props: {
    color: { type: String, required: false, default: "" },
    textColor: { type: String, required: false, default: "" },
    mode: { type: String, required: false, default: "" },
    loading: { type: Boolean, required: false, default: false },
    link: {type: String, required: false, default: "" },
    btnWidth: { type: String, required: false, default: "155px" }
  }
};
</script>

<style scoped>
.btnBFont {
  text-align: center;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-transform: uppercase;
  opacity: 1;
}
.btnBStyle {
  text-transform: uppercase;
  color: #fff;
  background-color: #0062FF;
  border-radius: 4px;
  /*padding: 15px;*/
  /*max-width: 120px;*/
  /*height: 40px;*/
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  /*font-weight: bold;*/
  /*margin-left: 5px;*/
  /*margin-top: 24px; */
}
</style>
